// Header scroll behavior
$(window).on('scroll', function () {
  if ($(this).scrollTop() > 100) {
    $('.header-wrapper').addClass('scrolled_down');
  } else {
    $('.header-wrapper').removeClass('scrolled_down');
  }
});

// Footer accordion toggle
document.querySelectorAll('.footer-block__heading').forEach(heading => {
  heading.addEventListener('click', () => {

    // Remove header scroll class
    document.querySelector('.header-wrapper')?.classList.remove('scrolled_down');

    const currentBlock = heading.closest('.footer-block');
    const isActive = currentBlock.classList.contains('active');

    // Close all blocks first
    document.querySelectorAll('.footer-block').forEach(block => {
      block.classList.remove('active');
    });

    // Toggle current one
    if (!isActive) {
      currentBlock.classList.add('active');
    }
  });
});
